export enum AccountRoles {
    ADMIN = "admin",
    ORGANISATION = "organisation",
    DISTRIBUTOR = "distributor",
    SUPPLIER = "supplier"
}

export const accountRolesEnumValues = Object.values(AccountRoles);

export function isAccountRole(value: unknown): value is AccountRoles {
    return accountRolesEnumValues.includes(value as AccountRoles);
}
